<!doctype html>
<section>
    <div class="row py-4 px-5" style="background:#fff;margin:0;">
        <div class="col-12 py-1  px-0">
            <h3>SKILL</h3>
        </div>

        <div class="col-12">
            <h4 class="px-4">
            <i><em> FRONT END DEVELOPER</em></i>

            </h4>
        </div>


             
        <div  class="col-6 col-sm-4 col-lg-4 col-xl-4 pt-2  px-0" *ngFor="let skill of skills" >
            <div class="skill-container-general">
                <ng-container *ngIf="skill.booleanIcon">
                    <h5>{{ skill.name }}</h5>
                    
                    <i class=" {{ skill.parameterIcon }}" ></i>
                </ng-container>
                
                <ng-container *ngIf="skill.booleanImg" >
                    <h5>{{ skill.name }}</h5>
                    
                    
                    <img src="{{skill.srcImg}}" class="img-skill">
                </ng-container>
            </div>
 
        </div>


    </div>
</section>


  
 
  

  
   
     

       

        
    
      
    